"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _utils = require("../utils");
var _excluded = ["skipBlob"],
  _excluded2 = ["skipBlob"],
  _excluded3 = ["skipBlob"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The DerivativeService, is used to fetch entity manifest & thumbnails through DS API.
 *
 * For thumbnails,
 *   - The blob url is generated by https://nodejs.org/api/url.html#urlcreateobjecturlblob
 *   - Need call revokeObjectURL(blobUrl) to release the resource once useless. https://nodejs.org/api/url.html#urlrevokeobjecturlid
 * Related WIKIs
 *   https://wiki.autodesk.com/display/R13N/Race+to+AUS%3A+ACM+Namespace
 *   https://wiki.autodesk.com/display/saascore/Derivative+Service+REST+API+V2
 */
var DSService = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function DSService(sdk) {
    var _this;
    (0, _classCallCheck2["default"])(this, DSService);
    _this = _callSuper(this, DSService, [sdk]);
    _this.dsEndpoint_v2 = sdk.Config.getEnv('DS_V2');
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(DSService, _Base);
  return (0, _createClass2["default"])(DSService, [{
    key: "validateRequest",
    value:
    /**
     * Validate query parameters.
     *
     * @param params - The request parameters
     */
    function validateRequest(params) {
      // Log error if the scopes is empty.
      // Add a soft check here instead of hard check in the schema to avoid breaking any temporary state.
      // E.g. the scopes is loading or not ready.
      if (!params.scopes || params.scopes.length === 0) {
        console.error('[SDK] The scopes is empty, please check the request parameters.');
      }
    }

    /**
     * Get resource blob by url
     *
     * @param url - The resource url path with detail query parameters.
     * @param config - Configurable object for overwrite request parameters.
     * @returns The resource url or blob url.
     */
  }, {
    key: "getResourceBlob",
    value: (function () {
      var _getResourceBlob = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(url, config) {
        var response, mimeType, blob;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.HttpService.apigee.get(url, (0, _extends2["default"])({}, config, {
                responseType: 'arraybuffer'
              }));
            case 3:
              response = _context.sent;
              if (!(response.status === 204 || response.status === 202)) {
                _context.next = 7;
                break;
              }
              console.warn("[SDK] The resource is empty or thumbnail is generating.", response.status, url);
              return _context.abrupt("return", undefined);
            case 7:
              mimeType = response.headers['content-type'] || 'octet/stream';
              blob = new Blob([response.data], {
                type: mimeType
              });
              return _context.abrupt("return", URL.createObjectURL(blob));
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              console.error('[SDK] Failed to get resource blob.', url, _context.t0);
              return _context.abrupt("return", undefined);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 12]]);
      }));
      function getResourceBlob(_x, _x2) {
        return _getResourceBlob.apply(this, arguments);
      }
      return getResourceBlob;
    }()
    /**
     * Get manifest data.
     * It will return manifest data without channel, thumbnail, on demand items and etc.
     *
     * https://wiki.autodesk.com/pages/viewpage.action?spaceKey=saascore&title=Derivative+Service+REST+API+V2#DerivativeServiceRESTAPIV2-GetManifest(Default)
     *
     * @param urn - The resource urn. e.g. bubble url.
     * @param params - The additional query parameters
     * @param config - Configurable object for overwrite request parameters.
     * @returns The manifest resource object.
     */
    )
  }, {
    key: "getManifest",
    value: (function () {
      var _getManifest = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(urn, params, config) {
        var url;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.validateRequest(params);
              url = "".concat(this.dsEndpoint_v2, "/manifest/").concat(_utils.Base64.encode(urn)).concat(_qs["default"].stringify(params, {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma',
                skipNulls: true
              }));
              return _context2.abrupt("return", this.HttpService.apigee.get(url, config));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getManifest(_x3, _x4, _x5) {
        return _getManifest.apply(this, arguments);
      }
      return getManifest;
    }()
    /**
     * Get all manifest data.
     *
     * https://wiki.autodesk.com/pages/viewpage.action?spaceKey=saascore&title=Derivative+Service+REST+API+V2#DerivativeServiceRESTAPIV2-GetManifest(All)
     *
     * @param urn - The resource urn. e.g. bubble url.
     * @param params - The additional query parameters
     * @param config - Configurable object for overwrite request parameters.
     * @returns The manifest resource object.
     */
    )
  }, {
    key: "getManifestAll",
    value: (function () {
      var _getManifestAll = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(urn, params, config) {
        var url;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.validateRequest(params);
              url = "".concat(this.dsEndpoint_v2, "/manifest/").concat(_utils.Base64.encode(urn), "/all").concat(_qs["default"].stringify(params, {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma',
                skipNulls: true
              }));
              return _context3.abrupt("return", this.HttpService.apigee.get(url, config));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getManifestAll(_x6, _x7, _x8) {
        return _getManifestAll.apply(this, arguments);
      }
      return getManifestAll;
    }()
    /**
     * Get all manifest data.
     *
     * https://wiki.autodesk.com/pages/viewpage.action?spaceKey=saascore&title=Derivative+Service+REST+API+V2#DerivativeServiceRESTAPIV2-GetManifest(Status)
     *
     * @param urn - The resource urn. e.g. bubble url.
     * @param params - The additional query parameters
     * @param config - Configurable object for overwrite request parameters.
     * @returns The manifest resource object.
     */
    )
  }, {
    key: "getManifestStatus",
    value: (function () {
      var _getManifestStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(urn, params, config) {
        var url;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.validateRequest(params);
              url = "".concat(this.dsEndpoint_v2, "/manifest/").concat(_utils.Base64.encode(urn), "/status").concat(_qs["default"].stringify(params, {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma',
                skipNulls: true
              }));
              return _context4.abrupt("return", this.HttpService.apigee.get(url, config));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getManifestStatus(_x9, _x10, _x11) {
        return _getManifestStatus.apply(this, arguments);
      }
      return getManifestStatus;
    }()
    /**
     * Get entity content blob url by urn
     *
     * @param urn - The resource urn
     * @param params - The additional query parameters
     * @param config - Configurable object for overwrite request parameters.
     * @returns The resource url or blob url.
     */
    )
  }, {
    key: "getContentByUrn",
    value: (function () {
      var _getContentByUrn = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(urn, params, config) {
        var query, url, _ref, skipBlob, restConfig;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.validateRequest(params);
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma',
                skipNulls: true
              });
              url = "".concat(this.dsEndpoint_v2, "/derivatives/").concat(encodeURIComponent(urn)).concat(query);
              _ref = config || {}, skipBlob = _ref.skipBlob, restConfig = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
              if (!(skipBlob === true)) {
                _context5.next = 6;
                break;
              }
              return _context5.abrupt("return", url);
            case 6:
              _context5.next = 8;
              return this.getResourceBlob(url, restConfig);
            case 8:
              return _context5.abrupt("return", _context5.sent);
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getContentByUrn(_x12, _x13, _x14) {
        return _getContentByUrn.apply(this, arguments);
      }
      return getContentByUrn;
    }()
    /**
     * Get entity thumbnail blob url by urn
     *
     * @param urn - The resource urn. Either urn or bubbleUrn
     * @param params - The additional query parameters
     * @param config - Configurable object for overwrite request parameters.
     * @returns The resource url or blob url.
     */
    )
  }, {
    key: "getThumbnailByUrn",
    value: (function () {
      var _getThumbnailByUrn = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(urn, params, config) {
        var query, url, _ref2, skipBlob, restConfig;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.validateRequest(params);
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma',
                skipNulls: true
              });
              url = "".concat(this.dsEndpoint_v2, "/thumbnails/").concat(_utils.Base64.encode(urn)).concat(query);
              _ref2 = config || {}, skipBlob = _ref2.skipBlob, restConfig = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
              if (!(skipBlob === true)) {
                _context6.next = 6;
                break;
              }
              return _context6.abrupt("return", url);
            case 6:
              _context6.next = 8;
              return this.getResourceBlob(url, restConfig);
            case 8:
              return _context6.abrupt("return", _context6.sent);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getThumbnailByUrn(_x15, _x16, _x17) {
        return _getThumbnailByUrn.apply(this, arguments);
      }
      return getThumbnailByUrn;
    }()
    /**
     * Get thumbnail blob url by file type
     *
     * @param fileType - The entity file type.
     * @param params - The additional query parameters
     * @param config - Configurable object for overwrite request parameters.
     * @returns The resource url or blob url.
     */
    )
  }, {
    key: "getThumbnailByType",
    value: (function () {
      var _getThumbnailByType = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(fileType, params, config) {
        var query, url, _ref3, skipBlob, restConfig;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.validateRequest(params);
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma',
                skipNulls: true
              });
              url = "".concat(this.dsEndpoint_v2, "/thumbnails/fileType/").concat(fileType).concat(query);
              _ref3 = config || {}, skipBlob = _ref3.skipBlob, restConfig = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
              if (!(skipBlob === true)) {
                _context7.next = 6;
                break;
              }
              return _context7.abrupt("return", url);
            case 6:
              _context7.next = 8;
              return this.getResourceBlob(url, restConfig);
            case 8:
              return _context7.abrupt("return", _context7.sent);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getThumbnailByType(_x18, _x19, _x20) {
        return _getThumbnailByType.apply(this, arguments);
      }
      return getThumbnailByType;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'DerivativeService';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = DSService;